'use client'
import Text from '@/components/Text/Text'
import { useState } from 'react'
import Button from '@/components/Button/Button'
import { Stack } from '@christiankaindl/lyts'
import { theme } from '@/styles/theme.css'

export default function Description ({ text }: { text: string }) {
  const [expanded, setExpanded] = useState(false)

  return (
    <Stack gap={0}>
      <Text maxLines={expanded ? undefined : 2} color='secondary'>
          {text}
      </Text>
      <Button style={{ color: theme.colors.text.brand, textDecoration: 'underline', marginLeft: -6 }} variant='flat' size='tiny' color='brand' onClick={() => { setExpanded(!expanded) }}>{ expanded ? 'Weniger' : 'Mehr'} Lesen</Button>
    </Stack>
  )
}
